import React from "react";
import { trackEvent } from "../../../utils/analytics";

const downloadShapeFile = () => {
  trackEvent("download Shapefile from FAQ");
  const url = "https://buscAR.terras.app/app/files/template_area.zip";
  window.open(url, "_blank");
};

const openSICARLink = () => {
  trackEvent("click SICAR link");
  const url = "https://car.gov.br/publico/imoveis/index";
  window.open(url, "_blank");
};

export const questions_enUS = [
  {
    name: "Access",
    questions: [
      {
        question: "How can I register in the BusCAR?",
        answer: (
          <p>
            Just click "Register" on our home page. Enter your name, CPF
            (Individual Taxpayer’s Registration Number), e-mail and password and
            confirm "I have read and accept the Terms of Use and Privacy Policy"
            after this, click the "Register" button.
          </p>
        )
      },
      {
        question:
          "I have not received the registration confirmation email. What should I do?",

        answer: (
          <>
            <p>
              The login confirmation and password e-mails are sent to the e-mail
              address provided in the registration form. Some e-mail servers
              have anti-spam settings.
            </p>
            <p>
              These settings ensure that you will not receive unwanted messages
              in your mailbox. On the Internet, some people send advertising
              messages, chain letters, among others, without authorization from
              the recipient. The anti-spam prevents this from happening with
              your mailbox. Check whether the e-mail has arrived but it is in
              the "junk mail" folder.
            </p>
          </>
        )
      },
      {
        question: "I have forgotten my password. What should I do?",

        answer: (
          <>
            <p>
              To recover your password and continue using the BusCar services,
              you should click on the "Forgot your password?” option in the
              login area on the BusCar homepage and enter your e-mail address.
              Wait for the password reset email.
            </p>
          </>
        )
      },
      {
        question:
          "What is the password size and how can I make my password stronger?",

        answer: (
          <>
            <p>
              When creating a new password, make sure it is at least six
              characters long. Try to use a complex combination of at least six
              numbers, letters and punctuation marks. If the password entered is
              not strong enough, try combining upper and lower case letters or
              make the password bigger.
            </p>
          </>
        )
      }
    ]
  },

  {
    name: "Resources and queries",

    questions: [
      {
        question: "How do I inform a CPF or CNPJ for queries in the system?",

        answer: (
          <p>
            When accessing the system, enter the CPF or CNPJ numbers in the data
            entry box below "CPFs/CNPJs". When entering the valid CPF or CNPJ
            numbers, click the "enter" button on your computer keyboard.
          </p>
        )
      },
      {
        question: "Can I inform more than one CPF or CNPJ?",

        answer: (
          <p>
            Yes. You can inform as many CPFs or CNPJs as are of interest to your
            query. When entering a CPF or CNPJ, click on the "enter" button on
            your computer keyboard and the field for entering other data will be
            enabled.
          </p>
        )
      },
      {
        question: "How do I delete a CPF or CNPJ?",

        answer: (
          <p>
            When entering a valid CPF or CNPJ, it will be displayed in the data
            entry box with the letter "x" beside it. Click on the letter "x" and
            the CPF or CNPJ data will be deleted.
          </p>
        )
      },
      {
        question:
          "Which formats are accepted by the system for queries regarding the area of interest?",
        answer: (
          <>
            <p>You can send two file formats:</p>
            <ul>
              <li>
                Zipped Shapefile format file (
                <button className="link-button" onClick={downloadShapeFile}>
                  Download template
                </button>
                )
              </li>
              <li>
                Zipped file in the{" "}
                <button className="link-button" onClick={openSICARLink}>
                  SICAR Nacional format
                </button>
                (SICAR is the system of CAR - Rural Environmental Registry - of
                the Brazilian Forest Service)
              </li>
            </ul>
          </>
        )
      },
      {
        question: "How do I send a file to the system?",
        answer: (
          <>
            <p>
              You will need to have the file in one of the accepted formats
              saved on your computer. Click on "Add File" and an interaction box
              of your operating system will open; choose the file to send and
              click on send.
            </p>
            <p>
              Wait while the system processes the file. If processing is
              successful, a map, total area and municipality will be displayed
              on the system screen referring to the file sent.
            </p>
            <p>
              If the file sent is not supported by the system, the message "File
              type not supported" will be displayed.
            </p>
          </>
        )
      },
      {
        question: "Can I send more than one shapefile or CAR to the system?",
        answer: <p>No. You can only send one file per query.</p>
      },
      {
        question: "How do I delete an area sent to the system?",
        answer: (
          <p>
            After sending the file referring to the area of interest for query
            to the system and processing it successfully, a "remove file" button
            will be displayed, click on it and the file will be deleted, thus
            enabling that a new file is uploaded.
          </p>
        )
      },
      {
        question: "Can I make a query just by informing a CPF or CNPJ?",
        answer: (
          <p>
            Yes. When entering the CPF and CNPJ data, click the "continue"
            button. The consultation will be carried out without the area of
            interest, only with the CPF or CNPJ data informed.
          </p>
        )
      },
      {
        question: "Can I make a query just by informing an area of interest?",
        answer: (
          <p>
            Yes. When sending an area file to the system, click the "continue"
            button. The query will be effected only for the area of interest
            being informed.
          </p>
        )
      },
      {
        question:
          "I forwarded the information to the system, how do I manage the query?",
        answer: (
          <>
            <p>
              After informing the CPF or CNPJ data or sending an area file and
              clicking the "continue" button. A new screen will open. Two
              options will be provided:
            </p>
            <ul>
              <li>
                <span className="bold">Execute:</span> by clicking this option,
                you will be charged and will have access to the results of the
                query.
              </li>
              <li>
                <span className="bold">Save:</span> you will not be charged, but
                you will not have access to the results of the query.
              </li>
            </ul>
          </>
        )
      },
      {
        question:
          "What are the sources for the the data of the analyzed criteria?",

        answer: (
          <p>
            All data presented in the results of the queries made in the system
            are collected from official public databases.
          </p>
        )
      },
      {
        question: "How do I generate a file to print the query?",

        answer: (
          <p>
            After executing a query, a new screen will open with the informed
            data and area. Click the "export in pdf" button and a new screen
            will open with the document in .PDF format of your query for
            printing.
          </p>
        )
      }
    ]
  },
  {
    name: "Payments",
    questions: [
      {
        question: "What are the payment forms?",
        answer: (
          <p>
            The payment of your plan can be made through a bank slip or Visa or
            MasterCard credit card. We do not accept bank transfers.
          </p>
        )
      },
      {
        question: "How long does it take for my plan to be cleared?",
        answer: (
          <>
            <p>
              <span className="bold">Bank slip:</span> Payment can be cleared
              within 1 business day after bank processing.
            </p>
            <p>
              <span className="bold">Credit card:</span> Payment is cleared
              within 30 minutes, subject to analysis by the credit card
              operator.
            </p>
          </>
        )
      },
      {
        question: "Is the payment safe?",
        answer: (
          <p>
            Yes. Terras uses the Pagar.me service for payment processing, thus
            using the best security practices for your data, such as encryption
            and anti-fraud system. At no time will we contact you by message or
            phone by sending you a payment link. If this occurs, please contact
            us to report it.
          </p>
        )
      },
      {
        question:
          "I don't have a printer to print the payment slip. What should I do?",
        answer: (
          <p>
            In this case, just write down the number of the payment slip
            referring to the barcode at the top of the clearance receipt. This
            number can be used for payment at a lottery house, post office or
            through your internet banking system.
          </p>
        )
      },
      {
        question: "What municipality will the invoice be issued?",
        answer: (
          <p>
            The Electronic Services Invoice (NFS-e) will be issued by the
            Finance Secretary of Belém, Pará State, where the main office of
            Terras App Solutions is located.
          </p>
        )
      },
      {
        question:
          "How long will it take for me to receive the service invoice?",
        answer: (
          <p>
            You will receive it first in Provisional Service Receipt (RPS). This
            document is an intermediate to NFS-e generation. Within the deadline
            established by the city of Belém, Pará State, the RPS will be
            converted into NFS-e in up to 10 (ten) calendar days.
          </p>
        )
      },
      {
        question: "How will I take delivery of my service invoice?",
        answer: (
          <p>
            It will be forwarded to your e-mail address registered in the
            system.
          </p>
        )
      },
      {
        question:
          "I did not receive my invoice in my e-mail. What should I do?",
        answer: (
          <p>
            Contact us by phone:{" "}
            <span className="bold">+55 (91) 3204-2940</span> or by e-mail:{" "}
            <span className="bold">financeiro@terras.agr.br</span>
          </p>
        )
      }
    ]
  }
];
